import apiClient from "services/apiClient";

async function getReportGeospatialColumns(reportId: any) {
  const res = await apiClient.get(`/admin/reports/${reportId}/geospatial-columns`);
  return res.data;
}

export default getReportGeospatialColumns;